import React from 'react';
import { SegmentedControl } from '@tranquility-ai/theme-components/segmented-control';
import { useTimePilotT } from '@/i18n/useTimePilotT';
import '@tranquility-ai/theme-components/segmented-control.css';

export type ContentModerationPreviewSwitcherProps = {
  showObfuscatedPreview: boolean;
  onToggle: (showObfuscated: boolean) => void;
};

/**
 * Obfuscated / Original segment control — matches the media toolbar Capture
 * switcher and other dense-toolbar segmented controls.
 */
export function ContentModerationPreviewSwitcher({
  showObfuscatedPreview,
  onToggle,
}: ContentModerationPreviewSwitcherProps) {
  const t = useTimePilotT();
  return (
    <SegmentedControl
      aria-label={t('media.previewMode')}
      size="sm"
      variant="dark"
      value={showObfuscatedPreview ? 'obfuscated' : 'original'}
      onValueChange={(value) => onToggle(value === 'obfuscated')}
      options={[
        { value: 'obfuscated', label: t('media.obfuscated') },
        { value: 'original', label: t('media.original') },
      ]}
    />
  );
}
